export const BILLING_TYPES = {
	DEFAULT: {
		name: 'PADRÃO',
		key: 'default',
		guides: [
			{
				name: 'PADRÃO',
				key: 'default'
			},
			{
				name: 'NULO',
				key: 'none'
			},
		]
	},
	TISS: {
		name: 'TISS',
		key: 'tiss',
		guides: [
			{
				name: 'CONSULTA',
				key: 'consultation'
			},
			{
				name: 'SP/SADT',
				key: 'sp_sadt'
			},
		]
	},
}